import { lazy } from "react";
import { RouteProps } from "react-router-dom";

// cert
const CertificateTemplateListPage = lazy(() => import("pages/dashboard/cert/certTemplateList"));
const CertificateTemplateEditPage = lazy(() => import("pages/dashboard/cert/certTemplateEdit"));

// issued
const IssuedListPage = lazy(() => import("pages/dashboard/issued/issuedList"));

const protectedRoutes: RouteProps[] = [
  // cert
  {
    path: "certificate/template/list",
    Component: CertificateTemplateListPage,
  },
  {
    path: "certificate/template/edit/:id",
    Component: CertificateTemplateEditPage,
  },

  // issued
  {
    path: "certificate/issued/list",
    Component: IssuedListPage,
  },
];

export default protectedRoutes;
